nc_initTilt('.slider-addon-bottom', 'glare');
$(window).scroll(function () {
    var scrollTop = $(this).scrollTop();

    $('.slider .caption-wrapper .carousel-caption, .slider-addon-bottom, .mouse-icon, .arrow-slider').css({
        opacity: function () {
            var elementHeight = $(this).height();
            return 0 + (elementHeight - scrollTop / 2) / elementHeight;
        }
    });

});
$(document).ready(function(){
    $(".hamburger-info").click(function(){
        $(".hamburger-info, .website-wrapper-box, .info-wrapper-box").toggleClass("is-active");
    });
    var headerHeight = $(".header").outerHeight();
    $('.header').css({ 'margin-bottom':-headerHeight});

    var scrollElement = document.querySelector('#scroll');

    window.addEventListener('scroll', function(){
        var height = document.body.scrollHeight - this.innerHeight;
        var scrolledPixels = this.scrollY;
        var width = ((scrolledPixels / height) * 100).toFixed(2);
        scrollElement.style.width = width + '%';
    });
    $(window).load(function(){
        $('#preloader').fadeOut('slow',function(){});
    });

    $(".Special_Condolence .listblock").each(function() {
        $(this).find('a[href*="condolenceDetails"]').attr('target','_blank');
    });  

});
$( window ).resize(function() {
    var headerHeight = $(".header").outerHeight();
    $('.header').css({ 'margin-bottom':-headerHeight});
});